/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import React from "react";
import { humanDateFormat } from "../../../config/constants";
import "./styles.scss";

export const StaticTimeLine = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  const sortedItems = items.sort((a, b) => a.date.valueOf() - b.date.valueOf()).map((item) => ({ ...item, date: item.date.startOf("day") }));
  let distinctItems = 0;
  const uniqueItems = sortedItems.filter((item, i) => {
    if ((i + 2 !== sortedItems.length || distinctItems >= 1) && sortedItems[i + 1] && sortedItems[i + 1].date.valueOf() === item.date.valueOf()) {
      /*
       * La primer condicion es para asegurarnos que siempre haya al menos un item en cada extremo
       * evitar que si por ejemplo hay 3 fechas iguales, queden todas en el primer casillero juntas
       */
      sortedItems[i + 1].title = `${item.title} - ${sortedItems[i + 1].title}`;
      sortedItems[i + 1].color = sortedItems[i + 1].color || item.color;
      return false;
    }
    distinctItems += 1;
    return true;
  });
  const maxLeft = 400;
  const minLeft = 100;
  const maxDate = uniqueItems[uniqueItems.length - 1].date;
  const minDate = uniqueItems[0].date;
  const positions = [];
  for (let x = minLeft; x <= maxLeft - minLeft; x += minLeft) {
    positions.push(x);
  }
  uniqueItems.forEach((item, i) => {
    if (i === 0) {
      item.left = 0;
    } else if (item.date.valueOf() === maxDate.valueOf()) {
      item.left = maxLeft;
    } else {
      const desiredLeft = ((item.date.valueOf() - minDate.valueOf()) * maxLeft) / (maxDate.valueOf() - minDate.valueOf());
      for (const [leftIndex, left] of positions.entries()) {
        if (left <= desiredLeft && (!positions[leftIndex + 1] || positions[leftIndex + 1] > desiredLeft)) {
          item.left = left;
          positions.splice(leftIndex, 1);
          break;
        } else if (leftIndex === 0 && left >= desiredLeft) {
          item.left = left;
          positions.splice(leftIndex, 1);
          break;
        }
      }
    }
  });

  return (
    <div className="static-time-line" style={{ fontFamily: "Nunito" }}>
      <div className="hori-timeline" dir="ltr">
        <ul className="list-inline events">
          {uniqueItems.map((item, index) => (
            <React.Fragment key={item.title}>
              {index !== 0 && (
                <li className="list-inline-item event-days" style={{ left: `${(item.left + uniqueItems[index - 1].left) / 2}px` }}>
                  <p>{item.date.diff(uniqueItems[index - 1].date, "days")}d</p>
                </li>
              )}
              <li className="list-inline-item event-list" style={{ left: `${item.left}px` }}>
                <div
                  className="event-date"
                  style={{
                    background: `#${item.color || "e8727f"}`,
                    fontSize: "12px",
                  }}
                >
                  {item.date.format(humanDateFormat)}
                </div>
                <p>{item.title}</p>
              </li>
            </React.Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};
